module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("原退回空瓶數量: " + _vm._s(Math.abs(_vm.currentEvent.number1)))])]), (_vm.currentProgress === 'action') ? _c('ActionWrap', {
    attrs: {
      "actionProgress": _vm.actionProgress,
      "amountPayload": _vm.amountPayload
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b54e5fb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecycleEmptyFlow/ConfirmFlow.vue
// module id = 1537
// module chunks = 1